export const supportSubmissionContractVersion =
  "support-submission-v1" as const;

export type SupportSubmissionContractVersion =
  typeof supportSubmissionContractVersion;

export const supportSubmissionRoutePath =
  "/api/v1/support-submissions" as const;

export const supportSubmissionKinds = [
  "feedback",
  "bug-report",
  "chat-feedback",
] as const;

export type SupportSubmissionKind = (typeof supportSubmissionKinds)[number];

export const supportSubmissionStatuses = ["accepted"] as const;

export type SupportSubmissionStatus =
  (typeof supportSubmissionStatuses)[number];

export const supportSubmissionStorageLabels = [
  "control-plane-postgres",
  "control-plane-preview-log",
] as const;

export type SupportSubmissionStorageLabel =
  (typeof supportSubmissionStorageLabels)[number];

export interface SupportSubmissionRequestV1 {
  schemaVersion: SupportSubmissionContractVersion;
  tenantId: string;
  siteId?: string | null;
  subjectKey?: string | null;
  patientId?: string | null;
  submissionKind: SupportSubmissionKind;
  source: string;
  name?: string | null;
  emailAddress?: string | null;
  feedbackText?: string | null;
  bugContext?: string | null;
  bugImpact?: string | null;
  sentiment?: "helpful" | "needs-work" | null;
  messageId?: string | null;
  messageText?: string | null;
  pageUrl?: string | null;
  userAgent?: string | null;
}

export interface SupportSubmissionResponseV1 {
  schemaVersion: SupportSubmissionContractVersion;
  tenantId: string;
  submissionId: string;
  status: SupportSubmissionStatus;
  receivedAt: string;
  storageLabel: SupportSubmissionStorageLabel;
  summaryText: string;
}
